import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'
Vue.use(Router)

let router = new Router({
  base: '/jinneng/',
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  // NProgress.start();
  let token = sessionStorage.getItem('apptoken')
  if(to.path == '/'){
    next({path: '/Index'})
  }
  // 验证url是否需要token才能跳转
  // if (isExcludePath(to.path)) {
  //   next()
  //   return
  // }

  // token为空，跳转到 登录页面
  if (!token) {
    next()
  } else {
    // token不为空，判断当前user信息是否为空
    // 1.为空，根据token请求一次user信息
    // 2.不为空，next
    if (store.state.user) {
      next()
    } else {
      let params = {
        token: token
      }
      let res = await Vue.axios.post(`/api/user/findByToken`, params)
      if (res.code === 0) {
        let user = res.data
        store.commit('setUser', user)
        sessionStorage.setItem('apptoken', res.token)
        // 验证是否有权限
        next()
      } else {
        next()
      }
    }
  }
})

function isExcludePath (path) {
  let flag = false
  // 为了兼容IE，使用此写法
  for (let i = 0, length = excludePathList.length; i < length; i++) {
    let excludePath = excludePathList[i]
    if (path.indexOf(excludePath) !== -1) {
      flag = true
      break
    }
  }
  return flag
}

function hasAuth (path) {
  let flag = false
  if (path === '/') {
    return true
  }
  let navs = routes
  // 为了兼容IE，使用此写法
  for (let i = 0, length = navs.length; i < length; i++) {
    let nav = navs[i]
    let childrenPathList = nav.children.map(function (item) {
      return item.path
    })

    let pathArray = path.split('/')
    let childrenPath = pathArray[pathArray.length - 1]
    if (nav && childrenPathList.indexOf(childrenPath) !== -1) {
      flag = true
      break
    }
  }
  return flag
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js